<template lang="pug">
.modelapplication(v-if="modelReady || type !== 'model'")
  //- 模型左侧应用图标
  .modelLeft(v-if="leftList.length")
    .leftlayout
      img.logo(src="./modelProMax/images/logo.png", alt="图标")
      .meau
        .nav(v-for="(item, index) in leftList", :key="index", @mouseover.stop="mouseover(item)", @mouseleave.stop="mouseleave(item)", @click="openFun(item)")
          el-popover(trigger="hover", placement="right", popper-class="popperStyle", :content="item.cnName")
            template(slot="reference")
              img(:src="item.icon1", alt="标题", v-if="item.actived || item.hoverActive")
              img(:src="item.icon0", alt="标题", v-else)
  //- 模型下方应用图标
  .down(:class="downStyle", v-if="operList.length")
    .menu
      .operButton(
        v-for="(item, index) in operList",
        :title="item.cnName",
        :key="index",
        @click.stop="openFun(item, index)",
        @mouseover="mouseover(item)",
        @mouseleave="mouseleave(item)"
      )
        img.mainImage(:src="item.icon1", alt="图标", v-if="item.actived || item.hoverActive")
        img.mainImage(:src="item.icon0", alt="图标", v-else)
        img.mark(:src="markOn", alt="角标", v-if="item.hasMark === 'up'")
        img.mark(:src="markOff", alt="角标", v-else-if="item.hasMark === 'down'")
  //- 组件展示
  component(
    :is="app.component",
    v-for="app in activeApplication",
    :key="app.id",
    :type="type",
    :actionData="app",
    @openOther="openOther",
    @closeCom="closeCom",
    @addComment="addComment",
    @getCommentPosition="getPosition"
  )
  //- 底部应用图标的 工具展示区（小地图、测量、剖切）
  .tools
    component(:is="app.component", v-for="app in toolsHeight", :key="app.id", :type="type", :actionData="app", @openOther="openOther", @closeCom="closeCom")
    .narrow(:class="downStyle")
      .com(v-for="app in toolsApplication", :key="app.id", @click="openHeight(app)") {{ app.cnName }}...
</template>

<script>
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
import { getMapList, getModelMapList, getModelList, getOtherList } from "./application";
import { getToken } from "@/CommonDP/mongeView/utils";
import mongeService from "./service/monge-service";
export default {
  props: {
    type: {
      type: String,
      default: ""
    },
    hideIssue: {
      type: Boolean,
      default: false
    },
    edit: {
      type: String,
      default: ""
    },
    fileId: {
      type: String,
      default: ""
    }
  },
  data() {
    let showAllList = [];
    let downStyle;
    let appList;
    const { noNeedIssue, shareSource } = this.$route.query;
    const markOn = require("./modelProMax/images/markOn.png");
    const markOff = this.type === "model" ? require("./modelProMax/images/markOff.png") : require("./dwgProMax/images/markOff.png");
    switch (this.type) {
      case "dwg":
        appList = getMapList();
        downStyle = "dwgDown";
        break;
      case "model":
        appList = getModelList();
        downStyle = "modelDown";
        break;
      case "modelDwg":
        appList = getModelMapList();
        downStyle = "modelMapDown";
        break;
      default:
        appList = getOtherList();
        downStyle = "otherDown";
        break;
    }
    if (!getToken() || noNeedIssue === "true" || shareSource === 1 || shareSource === 2) {
      showAllList = appList.filter(({ id }) => id !== "issue" && id !== "list" && id !== "overlay" && id !== "edit" && id !== "endEdit" && id !== "cancelEdit");
    } else {
      if (this.edit === "view") {
        showAllList = appList.filter(({ id }) => id !== "endEdit" && id !== "cancelEdit");
      } else if (this.edit === "edit") {
        showAllList = appList.filter(({ id }) => id === "endEdit" || id === "cancelEdit");
      } else {
        showAllList = appList.filter(({ id }) => id !== "edit" && id !== "endEdit" && id !== "cancelEdit");
      }
    }
    return { showAllList, markOn, markOff, downStyle };
  },
  computed: {
    modelReady() {
      return mongeApp.model.modelReady;
    },
    // 是否是无轻量化的模型
    isNoLightweight() {
      return mongeApp.model.isNoLightweight;
    },
    modelInfoData() {
      // 模型信息
      return JSON.parse(mongeApp.model.fileInfo);
    },
    checkQuestionId() {
      // 问题ID
      return mongeApp.questionId;
    },
    // 底部应用按钮组件
    operList() {
      // 整合模型没有的应用（版本比对）
      if (this.isNoLightweight) {
        if (this.type === "model" && this.modelInfoData?.fileObj) {
          return this.showAllList.filter(({ button, id, isNolightweight }) => button === "bottom" && id !== "comparison" && isNolightweight);
        } else return this.showAllList.filter(({ button, isNolightweight }) => button === "bottom" && isNolightweight);
      } else {
        if (this.type === "model" && this.modelInfoData?.fileObj) {
          return this.showAllList.filter(({ button, id }) => button === "bottom" && id !== "comparison" && id !== "recorder");
        } else return this.showAllList.filter(({ button }) => button === "bottom");
      }
    },
    // 无图标组件（问题详情）
    otherList() {
      return this.showAllList.filter(({ button }) => button === "auto");
    },
    // 展示应用组件（非工具区）
    activeApplication() {
      return this.showAllList.filter(({ actived, component, isTools }) => actived && component && !isTools);
    },
    // 左侧应用按钮组件
    leftList() {
      return this.isNoLightweight ? [] : this.showAllList.filter(({ button }) => button === "left");
    },
    // 展示组件(最小化)
    toolsApplication() {
      return this.showAllList.filter(({ actived, component, isMini }) => actived && component && isMini);
    },
    // 工具区高亮应用（最多只有一个应用展示）
    toolsHeight() {
      return this.showAllList.filter(({ actived, component, isTools, heightLight }) => actived && component && isTools && heightLight);
    },
    hasList() {
      return mongeApp.hasList;
    }
  },
  watch: {
    checkQuestionId(val) {
      if (val) {
        this.openDetail();
      }
    },
    hasList(val) {
      if (val) {
        this.showAllList.forEach((e) => {
          if (e.id === "list") {
            e.open();
          }
        });
      }
    },
    edit(val) {
      if (val) {
        const { noNeedIssue, shareSource } = this.$route.query;
        this.appList = getOtherList();
        if (!getToken() || noNeedIssue === "true" || shareSource === 1 || shareSource === 2) {
          this.showAllList = this.appList.filter(({ id }) => id !== "issue" && id !== "list" && id !== "overlay" && id !== "edit" && id !== "endEdit" && id !== "cancelEdit");
        } else {
          if (this.edit === "view") {
            this.showAllList = this.appList.filter(({ id }) => id !== "endEdit" && id !== "cancelEdit");
          } else if (this.edit === "edit") {
            this.showAllList = this.appList.filter(({ id }) => id === "endEdit" || id === "cancelEdit");
          } else {
            this.showAllList = this.appList.filter(({ id }) => id !== "edit" && id !== "endEdit" && id !== "cancelEdit");
          }
        }
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const { questionId } = this.$route.query;
      // url非必填参数处理
      if (questionId) {
        this.openOther("list");
        mongeMutations.setQuestionId(questionId);
        this.openDetail();
      }
    },
    // 打开对应组件-点击高亮按钮时关闭组件
    async openFun(item, index, onlyoffice) {
      const that = this;
      this.showAllList.forEach(async (ele) => {
        if (ele.id === item.id && !ele.actived) {
          if (ele.id === "edit") {
            this.$emit("editOffice");
          } else if (ele.id === "endEdit") {
            this.$confirm("请先保存文档，再继续。此操作将会刷新当前页面。是否继续？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
              .then(() => {
                const { prjId, folderId, versionId } = this.$route.query;
                const param = { prjId, folderId, fileId: this.fileId, version: versionId };
                mongeService
                  .onlyOfficeSave(param)
                  .then((res) => {
                    if (res.result === "0") {
                      this.$message.success("保存成功");
                      const verIdNew = Number(versionId) + 1;
                      let url = window.location.href;
                      const versionIdBefore = url.substring(0, url.indexOf("versionId=") + 10);
                      const versionIdNew = versionIdBefore + verIdNew;
                      const versionIdAfter = url.substring(url.indexOf("&noNeedIssue"));
                      url = versionIdNew + versionIdAfter;
                      const versionBefore = url.substring(0, url.indexOf("version%3D") + 10);
                      const versionNew = versionBefore + verIdNew;
                      const versionAfter = url.substring(url.indexOf("%26onlyOffice"));
                      url = versionNew + versionAfter;
                      const onlyofficeBefore = url.substring(0, url.indexOf("onlyOffice%3D") + 13);
                      const onlyofficeNew = onlyofficeBefore + "0";
                      const onlyofficeAfter = url.substring(url.indexOf("%26token"));
                      url = onlyofficeNew + onlyofficeAfter;
                      window.location.replace(url);
                      that.$emit("viewOffice");
                    } else {
                      this.$message.error(res.message);
                    }
                  })
                  .catch(() => {});
              })
              .catch(() => {});
          } else if (ele.id === "cancelEdit") {
            this.$confirm("此操作将回滚对本文档的所有修改，且不可恢复，请确认是否继续？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
              .then(() => {
                mongeService.onlyOfficeCancel(this.fileId).then((res) => {
                  if (res.result === "0") {
                    this.$message.success("回滚成功");
                    window.close();
                  } else {
                    this.$message.error(res.message);
                  }
                });
              })
              .catch(() => {});
          } else {
            if (ele.id === "issue" && this.type === "onlyoffice" && !onlyoffice) {
              this.$message.warning("请右键文档页面添加批注");
              return;
            }
            ele.open();
          }
        } else if (ele.id === item.id && ele.actived) {
          ele.close();
        } else if (ele.actived) {
          ele.mini(); // 最小化
        }
      });
    },
    // 按钮组件触发其他按钮的应用
    openOther(data) {
      if (data === "list") {
        mongeMutations.setHasList(true);
        mongeMutations.changeRefreshKey();
      }
      this.showAllList.forEach((e) => {
        if (e.id === data) e.open();
      });
    },
    // 打开问题详情
    openDetail() {
      this.otherList.forEach((ele) => {
        if (ele.id === "detail") {
          ele.open(this.checkQuestionId);
        }
      });
    },
    // 按钮组件触发其他按钮的应用
    addComment(data, createFlag) {
      console.log("syncComment application-----");
      this.$emit("addComment", data, createFlag);
    },
    getPosition(data, quote) {
      console.log("getPosition application-----");
      this.$emit("getCommentPosition", data, quote);
    },
    // 最小化组件选择另一个高亮
    dealtoolsHeight() {
      const id = this.toolsApplication[this.toolsApplication.length - 1].id;
      this.showAllList.forEach((e) => {
        if (e.id === id) {
          e.open();
        }
      });
    },
    openHeight(app) {
      this.showAllList.forEach((ele) => {
        if (ele.id === app.id) {
          ele.openTools();
        } else if (ele.actived) {
          ele.mini();
        } else {
          ele.closeTools();
        }
      });
    },
    // 关闭组件 ：boolean为true时关闭组件,false为最小化
    closeCom(id, boolean, param) {
      this.showAllList.forEach(async (ele) => {
        if (ele.id === id) {
          if (boolean) {
            ele.mini();
          } else {
            if (id === "issue" && !param) {
              this.$emit("removeComment");
            } else if (id === "issue" && param) {
              this.$emit("addComment", param, true);
            }
            ele.close();
          }
        }
      });
    },
    mouseover(item) {
      item.hoverActive = true;
    },
    mouseleave(item) {
      item.hoverActive = false;
    }
  }
};
</script>

  <style lang="scss" scoped>
.leftlayout {
  position: fixed;
  left: 0;
  top: 0;
  width: 56px;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 4;
  .logo {
    margin-top: 12px;
    margin-bottom: 15px;
    max-width: 42px;
    object-fit: scale-down;
  }
  .meau {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .nav {
    width: 100%;
    height: 44px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      cursor: pointer;
    }
  }
}
.down {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 40px;
  .menu {
    position: relative;
    z-index: 4;
    margin: 0 auto ;
    width: min-content;
    height: 50px;
    //background: rgba(255, 255, 255, 0.8);
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }
  .operButton {
    width: 60px;
    padding: 0 10px;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    backdrop-filter: blur(5px) grayscale(10);
    .mainImage {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
    .mark {
      width: 5px;
      height: 5px;
      position: absolute;
      bottom: 12px;
      right: 5px;
      cursor: pointer;
    }
  }
}
.down.modelMapDown {
  left: calc(50% - 200px);
  width: 400px;
  background: rgba(0, 0, 0, 0.68);
}
.down.dwgDown {
  left: calc(50% - 250px);
  width: 500px;
  background: rgba(0, 0, 0, 0.68);
}
.down.otherDown {
  left: calc(50% - 100px);
  width: 200px;
  background: rgba(0, 0, 0, 0.68);
}
.tools {
  position: absolute;
  bottom: 95px;
  left: 0;
  right: 0;
  height: 30px;
  .narrow {
    position: absolute;
    right: 0;
    top: -35px;
    height: 30px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }
  .narrow.modelMapDown {
    left: 56px;
    right: auto;
  }
  .com {
    padding: 0 30px;
    height: 30px;
    line-height: 30px;
    background: rgba(255, 255, 255, 0.8);
    z-index: 4;
    border-radius: 8px;
    margin-right: 10px;
    cursor: pointer;
  }
  // background: rgba(255, 255, 255, 0.8);
  // z-index: 4;
}
</style>
  <style>
.el-popover.popperStyle {
  left: 44px !important;
  min-width: 80px;
  padding: 7px 14px;
}
</style>

